module.exports = __webpack_public_path__ + "static/img/zhichanServe.9f1749bb.png";